export function lowerFirst<T extends string | null | undefined>(str: T): T {
	if (str === undefined || str === null) {
		return str;
	}

	return `${str.charAt(0).toLowerCase()}${str.slice(1)}` as T;
}
